module.exports = __webpack_public_path__ + "img/1724041280958-mom kitchen.jpg.2d5355a8.webp";